export const Auth = Symbol('$auth')
